import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { appHelpers } from "../../_helpers";
import InlineDatePicker from "../../utils/InlineDatePicker";

import { Grid, FormControl } from "@material-ui/core";
import Add from "@material-ui/icons/AddBox";
import {appConstants} from "../../_constants";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
  airlineSelect: {
    marginTop: "0px",
  },
});

function SettingsPanel(props) {
  const {
    classes,
    currentExchange,
    handleChange,
    handleExchangeRate,
    openModal,
    handleClose,
    fullScreen,
    handleExchangeSave,
    disabled,
    date,
    dateLabel,
    handleDateChange,
    startDate,
    endDate,
    endLabel,
    startLabel,
    handleSearchPending,
    handleSearchApprove,
  } = props;

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  return (
    <div className={classes.root}>
      <form className={classes.container} noValidate>
        <Grid container spacing={24}>
          <Grid item md={12} xs={12}>
            <Button
              color={"regional"}
              onClick={handleExchangeRate}
              style={{
                float: "right",
                margin: "14px",
              }}
            >
              <Add /> Set New Exchange Rate
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          <Grid item md={3} xs={12}>
            <Card>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Amount />
                </CardIcon>
                <div style={{ color: "#212121" }}>
                  <p className={classes.cardCategory}>Today's Exchange Rate</p>
                  <h3 className={classes.cardTitle}>
                    &#8358;{" "}
                    {typeof currentExchange === "number"
                      ? appHelpers.numberWithCommas(currentExchange)
                      : currentExchange}
                  </h3>
                </div>
              </CardHeader>
            </Card>
          </Grid>

          <Grid item md={3} xs={12}>
            <div className="picker" style={{ marginTop: "5.5vw" }}>
              <InlineDatePicker
                Date={startDate}
                handleDateChange={(date) => handleDateChange(date, "startDate")}
                label={startLabel}
              />
            </div>
          </Grid>
          <Grid item md={3} xs={12}>
            <div className="picker" style={{ marginTop: "5.5vw" }}>
              <InlineDatePicker
                Date={endDate}
                handleDateChange={(date) => handleDateChange(date, "endDate")}
                label={endLabel}
              />
            </div>
          </Grid>
          <Grid item md={3} xs={12} style={{ marginTop: "5.5vw" }}>
            <Button
              color={"regional"}
              onClick={() => {
                handleSearchApprove();
                handleSearchPending();
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
        {/* </Grid> */}
        <Dialog
          fullScreen={fullScreen}
          open={openModal}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            style={{ backgroundColor: appConstants.REGIONAL_COLOR }}
          >
            <span style={{ color: "white", textTransform: "uppercase" }}>
              Set New Exchange Rate
            </span>
          </DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid item lg={6}>
                <FormControl
                  className={classNames(
                    classes.airlineSelect,
                    classes.formControl
                  )}
                >
                  <CustomInput
                    required
                    labelText="&#8358;"
                    id="newExchangeRate"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      name: "newExchangeRate",
                      type: "number",
                      onChange: handleChange,
                    }}
                  />
                  {/*{error && <span style={{color:'red'}}>{formError}</span>}*/}
                </FormControl>

                <div className="picker">
                  <InlineDatePicker
                    Date={date}
                    // maxDate={new Date()}
                    maxDate={addDays(new Date(), 1)}                   
                    handleDateChange={(date) => handleDateChange(date, "date")}
                    label={dateLabel}
                  />
                </div>
              </Grid>
              <Grid item lg={6}>
                <p style={{ marginTop: "50px", marginLeft: "39px" }}>
                  to &#36;1
                </p>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button
              disabled={disabled}
              onClick={handleExchangeSave}
              color={"regional"}
              autoFocus
            >
              Set
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
}

export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRate/settingsPanel.js